import type { District } from '../types/gameTypes';

/**
 * Colour-group metadata. The pictogram lives in `GameIcons.tsx` (custom SVG) so the
 * board never depends on platform emoji fonts.
 */
export const DISTRICT_META: Record<District, { label: string; short: string; price: number; bar: string }> = {
  DISTRICT_A: { label: 'Old Town · Warm Brown', short: 'Brown', price: 20, bar: '#8B5A2B' },
  DISTRICT_B: { label: 'Harbour · Sky Blue', short: 'Harbour', price: 40, bar: '#4A8FBF' },
  DISTRICT_C: { label: 'Innovation · Tangerine', short: 'Innovation', price: 80, bar: '#D97706' },
  DISTRICT_D: { label: 'Metropolis · Crimson', short: 'Metropolis', price: 130, bar: '#B91C3C' },
  DISTRICT_E: { label: 'Expansion Belt · Forest Green', short: 'Expansion', price: 100, bar: '#2F855A' },
  DISTRICT_F: { label: 'Outer Rim · Plum', short: 'Outer Rim', price: 150, bar: '#6D4C9F' },
  TRANSIT: { label: 'Transit · Deep Cobalt', short: 'Transit', price: 40, bar: '#3B5998' },
  FINANCIAL: { label: 'Financial · Goldenrod', short: 'Finance', price: 60, bar: '#C89A2A' },
  SPECIAL: { label: 'Special', short: 'Special', price: 20, bar: '#5A6478' },
};
